import React from 'react';
import { twMerge } from 'tailwind-merge';
import { HERO_MOCKUP } from '../data/assets';
import { BoardMotif, BreathWave, CircleOfMats } from './BoardMotif';
type ProductVisualProps = {
  className?: string;
  eager?: boolean;
};
type Cover = {
  vol: string;
  title: string;
  sub: string;
  band: string;
  art: 'mats' | 'rings' | 'wave';
  cls: string;
};

/**
 * Visual del producto. Si hay mockup principal (data/assets.ts), lo muestra;
 * si no, arma un abanico con 3 portadas de tomo diseñadas en código
 * (horizontales, como el formato real del pack).
 */
export function ProductVisual({
  className = '',
  eager = false
}: ProductVisualProps) {
  if (HERO_MOCKUP) {
    return <img src={HERO_MOCKUP} alt="The six Breathwork Session Ready volumes (Prepare, Breathe, Integrate, Circles, Workshops, Retreats & Online) on a wooden table with the Breath Card deck, in a breathwork studio at sunset" width={1024} height={688} loading={eager ? 'eager' : 'lazy'} className={twMerge('h-auto w-full rounded-2xl shadow-card', className)} data-id="element-211" data-mp="jamgvhv8smke" />;
  }
  const covers: Cover[] = [{
    vol: 'Volume 1 of 6',
    title: 'Prepare',
    sub: 'Screening, consent, space and your first sessions',
    band: 'bg-sage',
    art: 'rings',
    cls: 'left-0 top-0 -rotate-6'
  }, {
    vol: 'Volume 2 of 6',
    title: 'Breathe',
    sub: 'Themed 1:1 sessions and how to meet what arises',
    band: 'bg-teal',
    art: 'wave',
    cls: 'right-0 top-[8%] rotate-[5deg]'
  }, {
    vol: 'Volume 4 of 6',
    title: 'Circles',
    sub: 'Group breathwork circles ready to run',
    band: 'bg-ochre',
    art: 'mats',
    cls: 'left-[9%] bottom-0 z-10 -rotate-1'
  }];
  return <div className={`relative mx-auto aspect-[5/4] w-full max-w-[520px] ${className}`} role="img" aria-label="Three of the six volume covers: Prepare, Breathe and Circles" data-id="element-212" data-mp="12mzct64ykyhj">
      {covers.map(c => <div key={c.title} className={`absolute aspect-[16/10] w-[78%] overflow-hidden rounded-xl border border-sand-dark bg-cream shadow-card ${c.cls}`} data-id="element-213" data-mp="2xqxbsfpv4kgo">
          <div className={`h-1.5 w-full ${c.band}`} data-id="element-214" data-mp="36r3kloam8w9i" />
          <div className="relative flex h-full flex-col p-[6%]" data-id="element-215" data-mp="36piq1yoaxdbn">
            <span className="text-[8px] font-bold uppercase tracking-[1.4px] text-ink-muted sm:text-[10px]" data-id="element-216" data-mp="3bq6pn8qlj2hh">
              Breathwork Session Ready · {c.vol}
            </span>
            <span className="mt-1.5 max-w-[62%] font-display text-[18px] leading-[1.05] text-sage sm:text-[26px]" data-id="element-217" data-mp="3lnup2bz5cy5z">
              {c.title}
            </span>
            <span className="mt-1.5 max-w-[55%] border-t border-terra/60 pt-1.5 text-[8px] leading-snug text-ink-soft sm:text-[10px]" data-id="element-218" data-mp="3qfmegj6kgxuj">
              {c.sub}
            </span>
            {c.art === 'mats' && <CircleOfMats className="absolute bottom-[12%] right-[4%] w-[40%] text-sage" data-id="element-219" data-mp="38abbnovetl5" />}
            {c.art === 'rings' && <BoardMotif className="absolute bottom-[12%] right-[6%] w-[32%] text-teal" data-id="element-220" data-mp="ideqdq0qfxu9" />}
            {c.art === 'wave' && <BreathWave className="absolute bottom-[22%] right-[5%] w-[40%] text-teal" data-id="element-221" data-mp="dcqqeeuj06nw" />}
          </div>
        </div>)}
    </div>;
}